import getByExerciseIdExerciseLogSummarySelector from '../get-by-exercise-id'
import { createSelector } from 'reselect'
import { EXERCISE_ID } from '../../../exercise/constants'

const getBarbellDeadliftExerciseLogSummarySelect = createSelector(
  getByExerciseIdExerciseLogSummarySelector(EXERCISE_ID.BARBELL_DEADLIFT),
  (instance) => instance
)

export default getBarbellDeadliftExerciseLogSummarySelect
